import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/auth";
import "./Loan.css";
import { toast } from "react-toastify";
import { useCombinedContext } from "../../context/CombinedContext";

// Define the initial form data for a single repayment
const initialFormData = {
  date: new Date().toISOString().split("T")[0], // "YYYY-MM-DD"
  amount: "",
};

const LoanRepayment = ({ formatPrice, loan, onClose }) => {
  const { user } = useCombinedContext();
  const authData =
    JSON.parse(localStorage.getItem("authData")) ||

    JSON.parse(sessionStorage.getItem("authData"));
  const currentUserId = authData?._id;

  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);
  // console.log("loan frontend",loan)
  // Prevent background scrolling when modal is open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) {
      onClose();
    }
  };

  // Update form state when inputs change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Submit the repayment data to the backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Build the payload using the updated form data
    const payload = {
      enteredBy: currentUserId,
      date: formData.date,
      amount: formData.amount,
    };

    try {
      // Assuming the correct endpoint for repayment is /loan/repayment
      const response = await axiosInstance.post(
        `/loan/repayment/${loan.employee._id}`,
        payload
      );
      toast.success("Repayment updated successfully");
      // console.log("Response for repayment", response);
      onClose();
    } catch (error) {
      // console.log("error", error);
      toast.error(
        error?.response?.data?.message?.[0] || "Something went wrong!"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      onClick={handleOutsideClick}
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content loan_model">
          <div className="modal-header text-white text-center vesel_form">
            <h5 className="modal-title">Payment Form</h5>
            <button
              type="button"
              className="btn-close text-white"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body vesel_form">
            <div className="container">
              <div className="row mb-2">
                <div className="col-md-6">
                  <h6>
                    <strong>Employee Name:</strong> {loan.employee.name}
                  </h6>
                </div>
                <div className="col-md-6">
                  <h6>
                    <strong>Loan Amount:</strong> ${" "}
                    {formatPrice(loan.balanceAmount)}
                  </h6>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="card shadow-sm mb-4 rounded-3">
                <div className="card-body">
                  <h5 className="card-title text-center mb-4">
                    Repayment Details
                  </h5>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        name="amount"
                        value={formData.amount}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-4 text-center">
                <button type="submit" className="button-2" disabled={loading}>
                  {loading ? "Processing..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanRepayment;
